/**
 * i18n
 * @author wwl
 * @created 2024/10/27
 * @modified 2024/10/27
 */
import { defineStore } from 'pinia'

export const useI18nStore = defineStore('i18n', {
  state: (): { locale: ELocale } => ({
    locale: ELocale.en
  }),
  actions: {
    setLang(data: ELocale) {
      this.locale = data
    }
  }
})
